<div class="meta-indicador-realizado-perc-progress">
    <div class="meta-indicador-realizado-perc-progress-value">
        {{perc | decimalFormat: 1:0:0}}%
    </div>
    <div class="progress"
        [style.height]="progressHeight"
        [title]="indicador?.nome">
        <div class="progress-bar" role="progressbar"
            [style.background-color]="indicador?.cor"
            [style.width]="perc + '%'"
            [attr.aria-valuenow]="perc" 
            aria-valuemin="0" 
            aria-valuemax="100">
        </div>
    </div>
</div>